module.exports = __webpack_public_path__ + "static/clock-3c591501da224ba0ec5eb031313b6fdd.jpg";